export default __webpack_public_path__ + "static/media/custom_screen_s.e2884f05.jpg";